var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchTutorialGIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 17.2171 17.2171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.1811 8.78806C16.1811 8.2285 16.1309 7.69046 16.0376 7.17395H8.60557V10.23H12.8525C12.6659 11.2128 12.1064 12.045 11.2671 12.6045V14.5917H13.8281C15.3203 13.2143 16.1811 11.1913 16.1811 8.78806Z",
    fill: "var(--fill-0, #3AAED7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.59947 16.4987C10.7301 16.4987 12.5164 15.7957 13.822 14.5905L11.261 12.6033C10.5579 13.0768 9.66119 13.3637 8.59947 13.3637C6.54776 13.3637 4.80452 11.9792 4.1804 10.114H1.55479V12.1514C2.85325 14.7268 5.51473 16.4987 8.59947 16.4987Z",
    fill: "var(--fill-0, #3AAED7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.19439 10.1067C4.03657 9.63322 3.94331 9.13105 3.94331 8.60736C3.94331 8.08368 4.03657 7.58151 4.19439 7.10804V5.07068H1.56878C1.03074 6.1324 0.72227 7.33043 0.72227 8.60736C0.72227 9.8843 1.03074 11.0823 1.56878 12.1441L3.61331 10.5515L4.19439 10.1067Z",
    fill: "var(--fill-0, #3AAED7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.59947 3.85856C9.76162 3.85856 10.7947 4.26029 11.6196 5.03506L13.8794 2.77531C12.5092 1.49838 10.7301 0.716431 8.59947 0.716431C5.51473 0.716431 2.85325 2.48836 1.55479 5.07093L4.1804 7.10829C4.80452 5.2431 6.54776 3.85856 8.59947 3.85856Z",
    fill: "var(--fill-0, #3AAED7)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchTutorialGIcon);
export default __webpack_public_path__ + "static/media/search-tutorial-g-icon.362c32eae4ae984e829597ed2d6e99cf.svg";
export { ForwardRef as ReactComponent };